/**
 * Custom Translation Hook - Workaround for i18next bug
 * Directly accesses resource bundles instead of using broken t() function
 */
import { useTranslation as useI18nextTranslation } from 'react-i18next';
import { useLanguage } from '../i18n/LanguageProvider';

export function useCustomTranslation() {
  const { i18n } = useI18nextTranslation();
  const { language: _language } = useLanguage(); // Force re-render on language change
  
  const t = (key: string, options?: any): string => {
    const currentLng = i18n.language;
    const bundle = i18n.getResourceBundle(currentLng, 'translation');
    
    if (!bundle) {
      console.warn(`No bundle found for language: ${currentLng}`);
      return key;
    }
    
    // Parse the key path (e.g., "language.label" -> ["language", "label"])
    const keys = key.split('.');
    let value: any = bundle;
    
    // Traverse the object tree
    for (const k of keys) {
      if (value && typeof value === 'object' && k in value) {
        value = value[k];
      } else {
        console.warn(`Translation key not found: ${key} in ${currentLng}`);
        return key;
      }
    }
    
    // Handle interpolation if options provided
    if (typeof value === 'string' && options) {
      return value.replace(/\{\{(\w+)\}\}/g, (match, p1) => {
        return options[p1] !== undefined ? String(options[p1]) : match;
      });
    }
    
    return typeof value === 'string' ? value : key;
  };
  
  return { t, i18n };
}
